document.addEventListener('DOMContentLoaded', () => {
  let projectPlanningCard = document.getElementById('project-planning-card')
  if(projectPlanningCard) {
    const urlParams = new URLSearchParams(window.location.search);
    console.log('urlParams', urlParams)
    if (urlParams.has('hl_planning_card') && urlParams.get('hl_planning_card') === '1') {
       setTimeout(function(){
        urlParams.delete('hl_planning_card');
        const newUrl = window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : '');
        window.history.replaceState(null, '', newUrl);
       }, 2500)
    }
  }
})